import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { apiErr } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Logo } from "@/components/Logo";
import { Lock, Loader2 } from "lucide-react";

export default function AdminLogin() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await login(email, password);
      nav("/admin");
    } catch (e) {
      setError(apiErr(e, "Invalid email or password"));
    } finally {
      setLoading(false);
    }
  };

  const field = "bg-input border-gold/25 text-cream placeholder:text-cream/30 rounded-xl h-12";

  return (
    <div className="min-h-screen bg-obsidian flex items-center justify-center px-4">
      <div className="w-full max-w-sm">
        <div className="flex justify-center mb-8"><Logo showTagline /></div>
        <form onSubmit={submit} className="gold-border-card rounded-2xl bg-card-surface p-8" data-testid="admin-login-form">
          <div className="flex items-center gap-2 text-gold mb-6"><Lock size={20} /><h1 className="font-serif text-2xl">Owner Login</h1></div>
          <div className="space-y-4">
            <div><Label className="text-cream/70 text-sm">Email</Label><Input type="email" className={field} value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-email-input" /></div>
            <div><Label className="text-cream/70 text-sm">Password</Label><Input type="password" className={field} value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-password-input" /></div>
            {error && <p className="text-destructive text-sm" data-testid="admin-login-error">{error}</p>}
            <Button type="submit" className="btn-gold w-full rounded-full py-6 font-semibold" disabled={loading} data-testid="admin-login-submit">
              {loading ? <Loader2 className="animate-spin" size={18} /> : "Sign In"}
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
}
